import { render, staticRenderFns } from "./modal-notice.vue?vue&type=template&id=118bb13c&scoped=true"
import script from "./modal-notice.vue?vue&type=script&lang=js"
export * from "./modal-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118bb13c",
  null
  
)

export default component.exports